import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Label, Input } from "reactstrap";
import { DateRangePicker, createStaticRanges } from "react-date-range";

import moment from "moment";

import "./style.css";

const DateRange = ({ dateRange, onChange, isFromDataUsage, minDate, maxDate, label="", className="", displayValue="" }) => {
  const [showCalender, setShowCalender] = useState(false);
  const [dateCount, setDateCount] = useState(0);
  const wrapperRef = useRef(null);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const staticRanges = useMemo(() => createStaticRanges([
    ...(isFromDataUsage
      ? [
          {
            label: 'Last 3 Months',
            range: () => ({
              startDate: moment().subtract(3, 'months').startOf('month').toDate(),
              endDate: moment().subtract(1, 'months').endOf('month').toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
          {
            label: 'Last 6 Months',
            range: () => ({
              startDate: moment().subtract(6, 'months').startOf('month').toDate(),
              endDate: moment().subtract(1, 'months').endOf('month').toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
        ]
      : [
          {
            label: 'Last 30 Days',
            range: () => ({
              startDate: moment().subtract(29, 'days').toDate(),
              endDate: moment().toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
          {
            label: 'Today',
            range: () => ({
              startDate: moment().toDate(),
              endDate: moment().toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
          {
            label: 'Yesterday',
            range: () => ({
              startDate: moment().subtract(1, 'days').toDate(),
              endDate: moment().subtract(1, 'days').toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
          {
            label: 'This Week',
            range: () => ({
              startDate: moment().startOf('week').toDate(),
              endDate: moment().endOf('week').toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
          {
            label: 'Last Week',
            range: () => ({
              startDate: moment().subtract(1, 'week').startOf('week').toDate(),
              endDate: moment().subtract(1, 'week').endOf('week').toDate(),
              isStaticSelectionClick: isSafari ? false : true,
            }),
          },
        ]
    ),
    {
      label: 'This Month',
      range: () => ({
        startDate: moment().startOf('month').toDate(),
        endDate: moment().endOf('month').toDate(),
        isStaticSelectionClick: isSafari ? false : true,
      }),
    },
    {
      label: 'Last Month',
      range: () => ({
        startDate: moment().subtract(1, 'month').startOf('month').toDate(),
        endDate: moment().subtract(1, 'month').endOf('month').toDate(),
        isStaticSelectionClick: isSafari ? false : true,
      }),
    },
  ]), [isFromDataUsage, isSafari]);

  const calenderChange = (ranges) => {
    let newRange = { ...ranges.rollup, isStaticSelectionClick: false };

    if (isFromDataUsage) {
      newRange.startDate = moment(newRange.startDate).startOf('month').toDate();
      newRange.endDate = moment(newRange.endDate).endOf('month').toDate();
    }

    onChange([newRange]);

    if (ranges?.rollup?.isStaticSelectionClick === true) {
      setShowCalender(false);
      setDateCount(0);
    } else {
      if (dateCount == 1) {
        setTimeout(() => {
          setShowCalender(false);
          setDateCount(0);
        }, 500);
      } else {
        setDateCount(1);
      }
    }
  };

  const closeCalendar = () => {
    setShowCalender(false);
    setDateCount(0);
  };

  useEffect(() => {
    if (!showCalender) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (!wrapperRef.current?.contains(event.target)) {
        closeCalendar();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeCalendar();
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showCalender]);
  return (
    <Fragment>
    {/* // <div className="card-deck campaign_date_range"> */}
    <div
      className={`campaign_date_range ${showCalender ? "is-open" : ""} ${className}`.trim()}
      ref={wrapperRef}
    >
      {label && <Label id="date_range_label" for="date_range_input">
        {label}
      </Label>}
      <Input
        className="bg-white"
        id="date_range_input"
        readOnly
        onClick={() => {
          if (showCalender === true) {
            setDateCount(0);
          }
          setShowCalender(!showCalender);
        }}
        style={{
          borderColor: 'hsl(0, 0%, 80%)',
          borderRadius: '4px',
          borderStyle: 'solid',
          borderWidth: '1px'
        }}
        value={
          displayValue ||
          (moment(dateRange[0].startDate).format("MM-DD-YYYY") +
            " - " +
            moment(dateRange[0].endDate).format("MM-DD-YYYY"))
        }
      />

      {showCalender ? (
        <div className="calender_wrapper">
          <DateRangePicker
            startDatePlaceholder="Start Date"
            endDatePlaceholder="End Date"
            ranges={dateRange}
            showPreview={false}
            showSelectionPreview={false}
            onChange={(ranges) => calenderChange(ranges)}
            staticRanges={staticRanges}
            inputRanges={[]}
            months={isFromDataUsage ? 2 : 1} 
            minDate={minDate}
            maxDate={maxDate}
            />
          <div
            className="date-range-actions"
            onClick={closeCalendar}
            role="button"
            tabIndex={-1}
          >
            <button
              type="button"
              className="btn btn-danger"
              onClick={(event) => {
                event.stopPropagation();
                closeCalendar();
              }}
            >
              Cancel
            </button>
          </div>
          </div>
        ) : null}
        </div>
      </Fragment>
    );
  };
  
  export default DateRange;
